import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Sets an Avoid Favor Set as default or not
 * @param setId Set ID of the Avoid Favor Set
 * @param defaultSet Whether the Avoid Favor Set will be set as default
 */
export function putAvoidFavorSetsDefault(
  this: unknown,
  setId: number,
  defaultSet: boolean
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment
          .resolve(this)
          .avoidFavorSetsIdDefaultUrl(setId)}/${defaultSet.toString()}`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
        message: z.string(),
      })
    )
  );
}
